module.exports = "<h1><b><mat-card-title>{{title | translate}}</mat-card-title></b></h1>\r\n"